export default __webpack_public_path__ + "static/media/img-0631-moldova-half-face.f46a4f21.png";